import { forwardRef, useEffect } from 'react';

// material-ui
import {
    FormHelperText,
    Grid,
    TextField,
    IconButton,
    DialogContent,
    Dialog,
    Zoom,
    Stack,
    Button
} from '@mui/material';
import HighlightOffTwoToneIcon from '@mui/icons-material/HighlightOffTwoTone';

// project imports
import MainCard from 'ui-component/cards/MainCard';
import useApi from 'hooks/useApi';
import MasterService from 'services/MasterService';
import cancellationRuleSchema from 'utils/schema/CancelationRuleSchema';
import { gridSpacing } from 'store/constant';

// third party
import { useFormik } from 'formik';

const Transition = forwardRef((props, ref) => <Zoom ref={ref} {...props} />);

export const CreateCancellation = ({ open, handleClose, selectedRule, setReload }) => {

    const updateRuleInfo = () => {
        const formikValues = { ...formik.values };
        formikValues.percentage = parseFloat(formikValues.percentage);
        if (selectedRule) {
            updateStApi.execute(formikValues, selectedRule.uuid);
        } else {
            createStApi.execute(formikValues);
        }
    };

    const updateCrHandler = () => {
        formik.resetForm()
        setReload(r => !r);
        handleClose();
    };

    const closeDialog = () => {
        formik.resetForm();
        handleClose();
    };

    const createStApi = useApi(MasterService.createCancellationRule, updateCrHandler, true);
    const updateStApi = useApi(MasterService.updateCancelationRuleByUuid, updateCrHandler, true);

    const formik = useFormik({
        initialValues: {
            start: selectedRule && selectedRule.start ? parseInt(selectedRule.start) : '',
            end: selectedRule && selectedRule.end ? parseInt(selectedRule.end) : '',
            percentage: selectedRule && selectedRule.percentage ? parseInt(selectedRule.percentage) : '',
        },
        validationSchema: selectedRule ? cancellationRuleSchema : cancellationRuleSchema,
        onSubmit: updateRuleInfo
    });

    useEffect(() => {
        if (selectedRule) {
            formik.setFieldValue('start', selectedRule.start ? parseInt(selectedRule.start) : '');
            formik.setFieldValue('end', selectedRule.end ? parseInt(selectedRule.end) : '');
            formik.setFieldValue('percentage', selectedRule.percentage ? parseInt(selectedRule.percentage) : '');
        }
    }, [selectedRule]);

    return (
        <Dialog
            open={open}
            TransitionComponent={Transition}
            keepMounted
            onClose={closeDialog}
            fullWidth
            maxWidth="sm"
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
        >
            <DialogContent sx={{ p: 0 }}>
                <MainCard
                    title={`${selectedRule ? 'Edit' : 'Create'} Rule`}
                    secondary={
                        <IconButton onClick={closeDialog} size="large" aria-label="Close User">
                            <HighlightOffTwoToneIcon fontSize="small" />
                        </IconButton>
                    }>
                    <Grid container spacing={gridSpacing}>
                        <Grid item sm={6} md={12}>
                            <Grid container spacing={gridSpacing}>
                                <Grid item xs={12}>
                                    <TextField
                                        fullWidth
                                        label="Start From"
                                        name="start"
                                        error={Boolean(formik.touched.start && formik.errors.start)}
                                        value={formik.values.start}
                                        onBlur={formik.handleBlur}
                                        onChange={formik.handleChange}
                                    />
                                    {formik.touched.start && formik.errors.start && (
                                        <FormHelperText error id="standard-weight-helper-text-value-user">
                                            {formik.errors.start}
                                        </FormHelperText>
                                    )}
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        fullWidth
                                        label="End"
                                        name="end"
                                        error={Boolean(formik.touched.end && formik.errors.end)}
                                        value={formik.values.end}
                                        onBlur={formik.handleBlur}
                                        onChange={formik.handleChange}
                                    />
                                    {formik.touched.end && formik.errors.end && (
                                        <FormHelperText error id="standard-weight-helper-text-value-user">
                                            {formik.errors.end}
                                        </FormHelperText>
                                    )}
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        fullWidth
                                        label="Percentage*"
                                        name="percentage"
                                        error={Boolean(formik.touched.percentage && formik.errors.percentage)}
                                        value={formik.values.percentage}
                                        onBlur={formik.handleBlur}
                                        onChange={formik.handleChange}
                                    />
                                    {formik.touched.percentage && formik.errors.percentage && (
                                        <FormHelperText error id="standard-weight-helper-text-percentage-user">
                                            {formik.errors.percentage}
                                        </FormHelperText>
                                    )}
                                </Grid>
                                <Grid item xs={12}>
                                    <Stack direction="row" spacing={1} justifyContent="flex-end">
                                        <Button
                                            color="error"
                                            onClick={closeDialog}
                                        >
                                            Cancel
                                        </Button>
                                        <Button
                                            color="secondary"
                                            variant="contained"
                                            onClick={formik.handleSubmit}
                                        >
                                            {selectedRule ? 'Update' : 'Create'} Rule
                                        </Button>
                                    </Stack>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </MainCard >
            </DialogContent>
        </Dialog >
    );
};
